import React from 'react';
export const FieldErrors = (props) => {
    const errors = (props.errors || []).filter((e) => e.field === props.name);
    if (errors.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: "input__error" }, errors
        .map((e) => e.messages)
        .flat()
        .join('; ')));
};
